import React from "react";
import { getConfiguration } from "@Clients/default/config";

const defaultConfiguration = getConfiguration();

export const ConfigurationContext = React.createContext(defaultConfiguration);
ConfigurationContext.displayName = "ConfigurationContext";

export const ConfigurationProvider = ConfigurationContext.Provider;
